import React from 'react';
import { TopbarSlot } from '../v2/components';

// A screen's on/off state, in the shell's top bar beside the page it describes — the slot
// customer screens use for their own scope controls — rather than in a second page header.
export default function StaffStatus({ on, children }) {
  return <TopbarSlot>
    <span className={`staff-status${on ? ' is-on' : ''}`} role="status"><span className="staff-status-dot" aria-hidden="true" />{children}</span>
  </TopbarSlot>;
}
